var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "a-modal",
        {
          attrs: {
            title: "",
            centered: true,
            footer: null,
            closable: false,
            maskClosable: false,
            keyboard: false,
            width: 720,
            dialogClass: "global-bind-card-modal-class",
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("div", { staticClass: "bind-modal-con" }, [
            _c("h1", { staticClass: "bind-title" }, [
              _c("span", { staticClass: "title-emoji" }, [_vm._v("🚀")]),
              _c("span", [
                _vm._v(" " + _vm._s(_vm.$t("bindModalTitlePrefix")) + " "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.target_count) +
                      " " +
                      _vm._s(
                        _vm.camp == 1
                          ? _vm.$t("bindModalMatchedCustomer")
                          : _vm.$t("bindModalMatchedCandidate")
                      )
                  ),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("bindModalTitleSuffix")) + " "),
              ]),
            ]),
            _c("p", { staticClass: "bind-description" }, [
              _vm._v(" " + _vm._s(_vm.$t("bindModalDesc")) + " — "),
              _c("strong", [_vm._v(_vm._s(_vm.$t("bindModalDescBold")))]),
            ]),
            _c("div", { staticClass: "bind-campaign-card" }, [
              _c("div", { staticClass: "card-head" }, [
                _c("span", { staticClass: "pending-badge" }, [
                  _vm._v(_vm._s(_vm.$t("bindModalPendingBadge"))),
                ]),
                _c("span", { staticClass: "campaign-name" }, [
                  _vm._v(_vm._s(_vm.campaignName)),
                ]),
              ]),
              _c("p", { staticClass: "card-stats" }, [
                _c("strong", [_vm._v(_vm._s(_vm.target_count))]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.camp == 1
                        ? _vm.$t("bindModalStatsCustomerMatched")
                        : _vm.$t("bindModalStatsCandidateMatched")
                    ) +
                    " · " +
                    _vm._s(_vm.$t("bindModalStatsReplies")) +
                    " · " +
                    _vm._s(
                      _vm.$t("bindModalStatsCreated", { date: _vm.createdDate })
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("div", { staticClass: "bind-trial-notice" }, [
              _c("span", { staticClass: "trial-emoji" }, [_vm._v("🎁")]),
              _c("p", [
                _vm._v(" " + _vm._s(_vm.$t("bindModalNoticePrefix")) + " "),
                _c("strong", [_vm._v(_vm._s(_vm.$t("bindModalNoticeBold")))]),
                _vm._v(" " + _vm._s(_vm.$t("bindModalNoticeSuffix")) + " "),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "bind-action-row" },
              [
                _c(
                  "a-button",
                  {
                    staticClass: "btn-continue",
                    attrs: { type: "primary" },
                    on: { click: _vm.goPayStep1 },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("bindModalContinueBtn")) + " "),
                    _c("span", { staticClass: "arrow" }, [_vm._v("→")]),
                  ]
                ),
                _c(
                  "a-button",
                  { staticClass: "btn-edit", on: { click: _vm.goEdit } },
                  [_vm._v(" " + _vm._s(_vm.$t("bindModalEditBtn")) + " ")]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }